import { UserProfileModel } from '../UserProfileModel';
import { CoachResumeModel } from './CoachResumeModel'

export class CoachProfileModel extends UserProfileModel {
	sports: string[] = [];
	country: string = "";
	resume?: CoachResumeModel;

	load(obj: Partial<CoachProfileModel>): this{
		Object.assign(this, obj);
		if (obj['resume'] !== undefined){
			this.resume = new CoachResumeModel().load(obj['resume']);
		} 
		else {
			this.resume = new CoachResumeModel();
		}
		return this;
	}
}